import { Component } from "@angular/core";

@Component({
  selector: "global-svg-sprite",
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">

      <symbol id="editIconOne" viewBox="0 0 14 13" fill="none">
        <path
          d="M6.99998 12.3333H13M1 12.3333H2.11636C2.44248 12.3333 2.60554 12.3333 2.75899 12.2964C2.89504 12.2638 3.0251 12.2099 3.1444 12.1368C3.27895 12.0543 3.39425 11.939 3.62486 11.7084L12 3.33328C12.5523 2.781 12.5523 1.88557 12 1.33328C11.4477 0.780996 10.5523 0.780997 10 1.33328L1.62484 9.70844C1.39424 9.93904 1.27894 10.0543 1.19648 10.1889C1.12338 10.3082 1.0695 10.4383 1.03684 10.5743C1 10.7278 1 10.8908 1 11.2169V12.3333Z"
          stroke="var(--stroke-color, #98A2B3)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="trashIcon" viewBox="0 0 24 24" fill="none">
        <path
          d="M20.25 5.25H3.75"
          stroke="var(--stroke-color, #667182)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.75 9.75V15.75"
          stroke="var(--stroke-color, #667182)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.25 9.75V15.75"
          stroke="var(--stroke-color, #667182)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.75 5.25V19.5C18.75 19.6989 18.671 19.8897 18.5303 20.0303C18.3897 20.171 18.1989 20.25 18 20.25H6C5.80109 20.25 5.61032 20.171 5.46967 20.0303C5.32902 19.8897 5.25 19.6989 5.25 19.5V5.25"
          stroke="var(--stroke-color, #667182)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.75 5.25V3.75C15.75 3.35218 15.592 2.97064 15.3107 2.68934C15.0294 2.40804 14.6478 2.25 14.25 2.25H9.75C9.35218 2.25 8.97064 2.40804 8.68934 2.68934C8.40804 2.97064 8.25 3.35218 8.25 3.75V5.25"
          stroke="var(--stroke-color, #667182)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="arrowDown" viewBox="0 0 12 12" fill="none">
        <path
          d="M9.75 4.5L6 8.25L2.25 4.5"
          stroke="#7E8DA0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="arrowLeft" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_871_85)">
          <path
            d="M13.5 8H2.5"
            stroke="#2973E0"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7 3.5L2.5 8L7 12.5"
            stroke="#2973E0"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_871_85">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="downloadIcon" viewBox="0 0 14 14" fill="none">
        <path
          d="M4.70312 6.01562L7 8.3125L9.29688 6.01562"
          stroke="var(--stroke-color, white)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 2.1875V8.3125"
          stroke="var(--stroke-color, white)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.8125 8.3125V11.375C11.8125 11.491 11.7664 11.6023 11.6844 11.6844C11.6023 11.7664 11.491 11.8125 11.375 11.8125H2.625C2.50897 11.8125 2.39769 11.7664 2.31564 11.6844C2.23359 11.6023 2.1875 11.491 2.1875 11.375V8.3125"
          stroke="var(--stroke-color, white)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="closeIcon" viewBox="0 0 16 16" fill="none">
        <path
          d="M12.5 3.5L3.5 12.5"
          stroke="var(--stroke-color, #2d405d)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 12.5L3.5 3.5"
          stroke="var(--stroke-color, #2d405d)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="tickIcon" viewBox="0 0 16 16" fill="none">
        <path
          d="M13.5 4.5L6.5 11.5L3 8"
          stroke="var(--stroke-color, #EB3B3B)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="copyPasteIcon" viewBox="0 0 18 18" fill="none">
        <path
          d="M12.9375 5.0625H2.8125V15.1875H12.9375V5.0625Z"
          stroke="var(--stroke-color, #A1B1C6)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.0625 2.8125H15.1875V12.9375"
          stroke="var(--stroke-color, #A1B1C6)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="addIcon" viewBox="0 0 256 256" fill="none">
        <rect width="256" height="256" fill="none" />
        <line
          x1="40"
          y1="128"
          x2="216"
          y2="128"
          fill="none"
          stroke="var(--stroke-color, #2973E0)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="24"
        />
        <line
          x1="128"
          y1="40"
          x2="128"
          y2="216"
          fill="none"
          stroke="var(--stroke-color, #2973E0)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="24"
        />
      </symbol>

      <symbol id="subtractIcon" viewBox="0 0 256 256" fill="none">
        <rect width="256" height="256" fill="none" />
        <line
          x1="40"
          y1="128"
          x2="216"
          y2="128"
          fill="none"
          stroke="var(--stroke-color, #2973E0)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="24"
        />
      </symbol>

      <symbol id="shareIcon" viewBox="0 0 20 20" fill="none">
        <path
          d="M1.25 9.375C1.25 10.2038 1.57924 10.9987 2.16529 11.5847C2.75134 12.1708 3.5462 12.5 4.375 12.5C5.2038 12.5 5.99866 12.1708 6.58471 11.5847C7.17076 10.9987 7.5 10.2038 7.5 9.375C7.5 8.5462 7.17076 7.75134 6.58471 7.16529C5.99866 6.57924 5.2038 6.25 4.375 6.25C3.5462 6.25 2.75134 6.57924 2.16529 7.16529C1.57924 7.75134 1.25 8.5462 1.25 9.375Z"
          stroke="var(--stroke-color, #008CAB)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 5C12.5 5.8288 12.8292 6.62366 13.4153 7.20971C14.0013 7.79576 14.7962 8.125 15.625 8.125C16.4538 8.125 17.2487 7.79576 17.8347 7.20971C18.4208 6.62366 18.75 5.8288 18.75 5C18.75 4.1712 18.4208 3.37634 17.8347 2.79029C17.2487 2.20424 16.4538 1.875 15.625 1.875C14.7962 1.875 14.0013 2.20424 13.4153 2.79029C12.8292 3.37634 12.5 4.1712 12.5 5Z"
          stroke="var(--stroke-color, #008CAB)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 15C12.5 15.8288 12.8292 16.6237 13.4153 17.2097C14.0013 17.7958 14.7962 18.125 15.625 18.125C16.4538 18.125 17.2487 17.7958 17.8347 17.2097C18.4208 16.6237 18.75 15.8288 18.75 15C18.75 14.1712 18.4208 13.3763 17.8347 12.7903C17.2487 12.2042 16.4538 11.875 15.625 11.875C14.7962 11.875 14.0013 12.2042 13.4153 12.7903C12.8292 13.3763 12.5 14.1712 12.5 15Z"
          stroke="var(--stroke-color, #008CAB)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.28833 8.24247L12.7117 6.1333"
          stroke="var(--stroke-color, #008CAB)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.1709 10.7734L12.8292 13.6026"
          stroke="var(--stroke-color, #008CAB)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="shareIconOne" viewBox="0 0 14 14" fill="none">
        <path
          d="M12.1283 7.35437C12.2707 7.23231 12.3419 7.17128 12.368 7.09865C12.3909 7.03491 12.3909 6.96519 12.368 6.90144C12.3419 6.82882 12.2707 6.76779 12.1283 6.64573L7.18704 2.41036C6.9419 2.20025 6.81934 2.09519 6.71557 2.09262C6.62538 2.09038 6.53924 2.13 6.48225 2.19993C6.41667 2.28039 6.41667 2.44182 6.41667 2.76468V5.27025C5.17144 5.4881 4.03176 6.11907 3.18483 7.06647C2.26148 8.09935 1.75072 9.43602 1.75 10.8214V11.1784C2.36212 10.4411 3.12638 9.84468 3.99044 9.43017C4.75224 9.06472 5.57574 8.84823 6.41667 8.79119V11.2354C6.41667 11.5583 6.41667 11.7197 6.48225 11.8002C6.53924 11.8701 6.62538 11.9097 6.71557 11.9075C6.81934 11.9049 6.9419 11.7998 7.18704 11.5897L12.1283 7.35437Z"
          stroke="var(--stroke-color, #2D405D)"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="saveFileIcon" viewBox="0 0 20 20" fill="none">
        <path
          d="M3.125 7.13282V16.25C3.125 16.4158 3.19085 16.5747 3.30806 16.6919C3.42527 16.8092 3.58424 16.875 3.75 16.875H16.25C16.4158 16.875 16.5747 16.8092 16.6919 16.6919C16.8092 16.5747 16.875 16.4158 16.875 16.25V3.75C16.875 3.58424 16.8092 3.42527 16.6919 3.30806C16.5747 3.19085 16.4158 3.125 16.25 3.125H7.13282C7.05166 3.12472 6.97124 3.14044 6.89617 3.17128C6.8211 3.20211 6.75284 3.24745 6.69532 3.30469L3.30469 6.69532C3.24745 6.75284 3.20211 6.8211 3.17128 6.89617C3.14044 6.97124 3.12472 7.05166 3.125 7.13282Z"
          stroke="var(--stroke-color, #2973E0)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 13.75C11.2081 13.75 12.1875 12.7706 12.1875 11.5625C12.1875 10.3544 11.2081 9.375 10 9.375C8.79188 9.375 7.8125 10.3544 7.8125 11.5625C7.8125 12.7706 8.79188 13.75 10 13.75Z"
          stroke="var(--stroke-color, #2973E0)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.5 6.25H12.5V3.125"
          stroke="var(--stroke-color, #2973E0)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="dotHorizontalIcon" viewBox="0 0 15 3" fill="none">
        <path
          d="M7.5 3C8.32843 3 9 2.32843 9 1.5C9 0.671573 8.32843 0 7.5 0C6.67157 0 6 0.671573 6 1.5C6 2.32843 6.67157 3 7.5 3Z"
          fill="#2D405D"
        />
        <path
          d="M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z"
          fill="#2D405D"
        />
        <path
          d="M13.5 3C14.3284 3 15 2.32843 15 1.5C15 0.671573 14.3284 0 13.5 0C12.6716 0 12 0.671573 12 1.5C12 2.32843 12.6716 3 13.5 3Z"
          fill="#2D405D"
        />
      </symbol>


      <symbol id="infoIcon" viewBox="0 0 256 256" fill="none">
        <rect width="256" height="256" fill="none" />
        <circle
          cx="128"
          cy="128"
          r="96"
          fill="none"
          stroke="var(--stroke-color, #7E8DA0)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="16"
        />
        <path
          d="M120,120a8,8,0,0,1,8,8v40a8,8,0,0,0,8,8"
          fill="none"
          stroke="var(--stroke-color, #7E8DA0)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="16"
        />
        <circle cx="124" cy="84" r="12" fill="#7E8DA0" />
      </symbol>

      <symbol id="blubIcon" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_218_2570)">
          <path
            d="M8.75 18.75H11.25"
            stroke="#F0C419"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15 9.99995C15.0033 9.06402 14.7439 8.14595 14.2513 7.35018C13.7586 6.55441 13.0525 5.91288 12.2133 5.49859C11.374 5.0843 10.4353 4.91388 9.50404 5.00672C8.57273 5.09955 7.68617 5.45192 6.94523 6.02373C6.20429 6.59554 5.63871 7.36383 5.31285 8.2412C4.98698 9.11856 4.91392 10.0698 5.10196 10.9866C5.29 11.9035 5.73159 12.7491 6.37651 13.4274C7.02142 14.1057 7.84376 14.5893 8.74997 14.8233V16.2499H11.25V14.8233C12.3213 14.5487 13.271 13.926 13.9498 13.0529C14.6286 12.1798 14.998 11.1059 15 9.99995Z"
            stroke="#F0C419"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 2.5V1.25"
            stroke="#F0C419"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.5 8.75H18.75"
            stroke="#F0C419"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.25 10H2.5"
            stroke="#F0C419"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.3033 14.6783L16.1875 15.5625"
            stroke="#F0C419"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.8125 3.1875L4.69667 4.07167"
            stroke="#F0C419"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.3033 4.07167L16.1875 3.1875"
            stroke="#F0C419"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.8125 15.5625L4.69667 14.6783"
            stroke="#F0C419"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_218_2570">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="refeshIcon" viewBox="0 0 256 256" fill="none">
        <rect width="256" height="256" fill="none" />
        <path
          d="M64,64s24-24,64-24c56,0,88,56,88,56"
          fill="none"
          stroke="var(--stroke-color, #2973E0)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="16"
        />
        <path
          d="M192,192s-24,24-64,24c-56,0-88-56-88-56"
          fill="none"
          stroke="var(--stroke-color, #2973E0)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="16"
        />
        <polyline
          points="168 96 216 96 216 48"
          fill="none"
          stroke="var(--stroke-color, #2973E0)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="16"
        />
        <polyline
          points="88 160 40 160 40 208"
          fill="none"
          stroke="var(--stroke-color, #2973E0)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="16"
        />
      </symbol>

      <symbol id="watchIcon" viewBox="0 0 16 16" fill="none">
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="var(--fill-color, #A1B1C6)"
        />
        <path
          d="M6.40002 4.8L11.2 8L6.40002 11.2V4.8Z"
          fill="var(--center-fill-color, white)"
        />
      </symbol>

      <symbol id="plainTextIcon" viewBox="0 0 14 18" fill="none">
        <path
          d="M13.6922 5.43281L9.31719 1.05781C9.2591 0.999791 9.19015 0.953782 9.11428 0.922415C9.03841 0.891047 8.9571 0.874936 8.875 0.875H1.375C1.04348 0.875 0.725537 1.0067 0.491116 1.24112C0.256696 1.47554 0.125 1.79348 0.125 2.125V15.875C0.125 16.2065 0.256696 16.5245 0.491116 16.7589C0.725537 16.9933 1.04348 17.125 1.375 17.125H12.625C12.9565 17.125 13.2745 16.9933 13.5089 16.7589C13.7433 16.5245 13.875 16.2065 13.875 15.875V5.875C13.8751 5.7929 13.859 5.71159 13.8276 5.63572C13.7962 5.55985 13.7502 5.4909 13.6922 5.43281ZM9.5 12.75H4.5C4.33424 12.75 4.17527 12.6842 4.05806 12.5669C3.94085 12.4497 3.875 12.2908 3.875 12.125C3.875 11.9592 3.94085 11.8003 4.05806 11.6831C4.17527 11.5658 4.33424 11.5 4.5 11.5H9.5C9.66576 11.5 9.82473 11.5658 9.94194 11.6831C10.0592 11.8003 10.125 11.9592 10.125 12.125C10.125 12.2908 10.0592 12.4497 9.94194 12.5669C9.82473 12.6842 9.66576 12.75 9.5 12.75ZM9.5 10.25H4.5C4.33424 10.25 4.17527 10.1842 4.05806 10.0669C3.94085 9.94973 3.875 9.79076 3.875 9.625C3.875 9.45924 3.94085 9.30027 4.05806 9.18306C4.17527 9.06585 4.33424 9 4.5 9H9.5C9.66576 9 9.82473 9.06585 9.94194 9.18306C10.0592 9.30027 10.125 9.45924 10.125 9.625C10.125 9.79076 10.0592 9.94973 9.94194 10.0669C9.82473 10.1842 9.66576 10.25 9.5 10.25ZM8.875 5.875V2.4375L12.3125 5.875H8.875Z"
          fill="var(--fill-color, #A1B1C6)"
        />
      </symbol>

      <symbol id="musicIcon" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_729_259)">
          <path
            d="M16.6344 2.0086C16.5599 1.94956 16.4728 1.90853 16.3798 1.88875C16.2868 1.86896 16.1905 1.87094 16.0984 1.89454L6.09844 4.39454C5.96336 4.42831 5.84342 4.50621 5.75765 4.6159C5.67188 4.72558 5.6252 4.86077 5.625 5.00001V13.6016C5.10357 13.2532 4.48065 13.089 3.85524 13.1353C3.22982 13.1815 2.6378 13.4354 2.17323 13.8566C1.70867 14.2779 1.39823 14.8423 1.29124 15.4603C1.18425 16.0782 1.28684 16.7142 1.58273 17.2671C1.87861 17.82 2.3508 18.2582 2.92427 18.512C3.49773 18.7658 4.13957 18.8206 4.74779 18.6678C5.35601 18.515 5.89571 18.1633 6.28113 17.6686C6.66655 17.1739 6.87558 16.5646 6.875 15.9375V8.61329L15.625 6.42579V11.1016C15.1036 10.7532 14.4806 10.589 13.8552 10.6353C13.2298 10.6815 12.6378 10.9354 12.1732 11.3566C11.7087 11.7779 11.3982 12.3423 11.2912 12.9603C11.1842 13.5782 11.2868 14.2142 11.5827 14.7671C11.8786 15.32 12.3508 15.7582 12.9243 16.012C13.4977 16.2658 14.1396 16.3206 14.7478 16.1678C15.356 16.015 15.8957 15.6633 16.2811 15.1686C16.6666 14.6739 16.8756 14.0646 16.875 13.4375V2.50001C16.8748 2.40521 16.853 2.31171 16.8113 2.22658C16.7696 2.14144 16.7091 2.0669 16.6344 2.0086Z"
            fill="var(--fill-color, #A1B1C6)"
          />
        </g>
        <defs>
          <clipPath id="clip0_729_259">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="lockIcon" viewBox="0 0 18 18" fill="none">
        <path
          d="M14.625 6.1875H3.375C3.06434 6.1875 2.8125 6.43934 2.8125 6.75V14.625C2.8125 14.9357 3.06434 15.1875 3.375 15.1875H14.625C14.9357 15.1875 15.1875 14.9357 15.1875 14.625V6.75C15.1875 6.43934 14.9357 6.1875 14.625 6.1875Z"
          stroke="#2D343F"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.46875 6.1875V3.65625C6.46875 2.98492 6.73543 2.34109 7.21014 1.86639C7.68484 1.39168 8.32867 1.125 9 1.125C9.67133 1.125 10.3152 1.39168 10.7899 1.86639C11.2646 2.34109 11.5312 2.98492 11.5312 3.65625V6.1875"
          stroke="#2D343F"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 11.5312C9.46599 11.5312 9.84375 11.1535 9.84375 10.6875C9.84375 10.2215 9.46599 9.84375 9 9.84375C8.53401 9.84375 8.15625 10.2215 8.15625 10.6875C8.15625 11.1535 8.53401 11.5312 9 11.5312Z"
          fill="#2D343F"
        />
      </symbol>

      <symbol id="quizIcon" viewBox="0 -960 960 960" fill="none">
        <path
          d="M560-360q17 0 29.5-12.5T602-402q0-17-12.5-29.5T560-444q-17 0-29.5 12.5T518-402q0 17 12.5 29.5T560-360Zm-30-128h60q0-29 6-42.5t28-35.5q30-30 40-48.5t10-43.5q0-45-31.5-73.5T560-760q-41 0-71.5 23T446-676l54 22q9-25 24.5-37.5T560-704q24 0 39 13.5t15 36.5q0 14-8 26.5T578-596q-33 29-40.5 45.5T530-488ZM320-240q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320Zm0-80h480v-480H320v480ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Zm160-720v480-480Z"
          fill="var(--fill-color, #A1B1C6)"
        />
      </symbol>

      <symbol id="assignmentIcon" viewBox="0 -960 960 960" fill="none">
        <path
          d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm80-80h280v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80Zm200-190q13 0 21.5-8.5T510-820q0-13-8.5-21.5T480-850q-13 0-21.5 8.5T450-820q0 13 8.5 21.5T480-790ZM200-200v-560 560Z"
          fill="var(--fill-color, #A1B1C6)"
        />
      </symbol>

      <symbol id="handShakeIcon" viewBox="0 0 18 18" fill="none">
        <path
          d="M16.1182 8.15637L14.4641 8.98003L12.3213 4.88181L13.9954 4.04476C14.1198 3.98134 14.2643 3.96969 14.3972 4.01234C14.5302 4.05499 14.6409 4.14849 14.7052 4.27244L16.3525 7.42646C16.3859 7.48959 16.4064 7.55877 16.4127 7.62992C16.4189 7.70108 16.4109 7.77277 16.3891 7.84078C16.3672 7.90878 16.332 7.97174 16.2855 8.02594C16.239 8.08014 16.1821 8.12448 16.1182 8.15637Z"
          stroke="#D9A219"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.67874 8.9128L1.02472 8.08244C0.961033 8.05123 0.904273 8.00753 0.857814 7.95394C0.811356 7.90035 0.776148 7.83797 0.754283 7.7705C0.732418 7.70303 0.724343 7.63186 0.730538 7.5612C0.736733 7.49055 0.757071 7.42187 0.790344 7.35923L2.43767 4.20521C2.50211 4.08135 2.61236 3.98754 2.74494 3.94376C2.87753 3.89998 3.02196 3.9097 3.14749 3.97084L4.82159 4.80789L2.67874 8.9128Z"
          stroke="#D9A219"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.4644 8.98005L13.393 10.239L10.9287 12.7033C10.8615 12.7661 10.7802 12.8117 10.6915 12.8362C10.6029 12.8606 10.5097 12.8633 10.4198 12.8439L6.53585 11.8729C6.4649 11.8531 6.3988 11.8189 6.34166 11.7725L2.67871 8.91309"
          stroke="#D9A219"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.3931 10.2385L10.4467 8.09564L9.58955 8.73849C9.2182 9.01566 8.76722 9.1654 8.30384 9.1654C7.84046 9.1654 7.38948 9.01566 7.01813 8.73849L6.65652 8.46394C6.59537 8.41745 6.54479 8.35851 6.50814 8.291C6.47148 8.2235 6.44957 8.14898 6.44388 8.07238C6.43818 7.99578 6.44882 7.91884 6.47508 7.84666C6.50135 7.77448 6.54265 7.7087 6.59625 7.65367L9.22125 5.03537C9.27056 4.9863 9.32906 4.94744 9.39341 4.92101C9.45776 4.89458 9.52669 4.88111 9.59625 4.88135H12.3217"
          stroke="#D9A219"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.86133 4.80794L8.2966 3.80347C8.41866 3.76847 8.54919 3.77796 8.6649 3.83026L10.9819 4.8816"
          stroke="#D9A219"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.5 14.2568L5.48438 13.7479C5.40224 13.7293 5.32618 13.6901 5.26339 13.634L3.75 12.3215"
          stroke="#D9A219"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>


      <symbol id="closeDialogCrossIcon" viewBox="0 0 12 12" fill="none">
        <g clip-path="url(#clip0_1051_41)">
          <path
            d="M9.375 2.625L2.625 9.375"
            stroke="#2D343F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.375 9.375L2.625 2.625"
            stroke="#2D343F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1051_41">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="arrowRightIcon" viewBox="0 0 12 12" fill="none">
        <g clip-path="url(#clip0_553_2797)">
          <path
            d="M1.875 6H10.125"
            stroke="var(--stroke-color , #2973E0 )"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.75 2.625L10.125 6L6.75 9.375"
            stroke="var(--stroke-color , #2973E0 )"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_553_2797">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="closeBtnCrossIcon" viewBox="0 0 12 12" fill="none">
        <g clip-path="url(#clip0_1051_50)">
          <path
            d="M9.375 2.625L2.625 9.375"
            stroke="#2D343F"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.375 9.375L2.625 2.625"
            stroke="#2D343F"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1051_50">
            <rect width="12" height="12" rx="6" fill="white" />
          </clipPath>
        </defs>
      </symbol>



      <!-- Page builder icons [BEGIN] -->


      <symbol id="homeIcon" viewBox="0 0 19 19" fill="none">
        <path
          d="M6.4331 11.0833C6.78463 12.4491 8.02446 13.4583 9.5 13.4583C10.9755 13.4583 12.2154 12.4491 12.5669 11.0833M8.72234 2.18817L3.35302 6.36431C2.9941 6.64346 2.81464 6.78304 2.68535 6.95784C2.57083 7.11268 2.48552 7.28712 2.4336 7.47258C2.375 7.68195 2.375 7.9093 2.375 8.364V14.0917C2.375 14.9784 2.375 15.4218 2.54757 15.7605C2.69937 16.0584 2.94159 16.3006 3.23952 16.4524C3.57821 16.625 4.02158 16.625 4.90833 16.625H14.0917C14.9784 16.625 15.4218 16.625 15.7605 16.4524C16.0584 16.3006 16.3006 16.0584 16.4524 15.7605C16.625 15.4218 16.625 14.9784 16.625 14.0917V8.364C16.625 7.9093 16.625 7.68195 16.5664 7.47258C16.5145 7.28712 16.4292 7.11268 16.3146 6.95784C16.1854 6.78304 16.0059 6.64347 15.647 6.36431L10.2777 2.18817C9.99953 1.97184 9.86046 1.86368 9.7069 1.8221C9.57141 1.78541 9.42859 1.78541 9.2931 1.8221C9.13954 1.86368 9.00047 1.97184 8.72234 2.18817Z"
          stroke="#667085"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="searchIcon" viewBox="0 0 16 16" fill="none">
        <path
          d="M14.75 14.75L11.4875 11.4875M7.25 3.5C9.32107 3.5 11 5.17893 11 7.25M13.25 7.25C13.25 10.5637 10.5637 13.25 7.25 13.25C3.93629 13.25 1.25 10.5637 1.25 7.25C1.25 3.93629 3.93629 1.25 7.25 1.25C10.5637 1.25 13.25 3.93629 13.25 7.25Z"
          stroke="var(--stroke-color, #2D405D)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="copyIconOne" viewBox="0 0 13 13" fill="none">
        <path
          d="M5.675 1.00154C5.30372 1.00657 5.08083 1.02806 4.90061 1.11989C4.69363 1.22535 4.52535 1.39363 4.41989 1.60061C4.32806 1.78083 4.30657 2.00372 4.30154 2.375M10.625 1.00154C10.9963 1.00657 11.2192 1.02806 11.3994 1.11989C11.6064 1.22535 11.7746 1.39363 11.8801 1.60061C11.9719 1.78083 11.9934 2.00372 11.9985 2.37499M11.9985 7.32499C11.9934 7.69628 11.9719 7.91916 11.8801 8.09939C11.7746 8.30637 11.6064 8.47465 11.3994 8.58011C11.2192 8.67194 10.9963 8.69343 10.625 8.69846M12 4.3V5.4M7.60003 1H8.69998M2.76 12H6.94C7.55606 12 7.86409 12 8.09939 11.8801C8.30637 11.7746 8.47465 11.6064 8.58011 11.3994C8.7 11.1641 8.7 10.8561 8.7 10.24V6.06C8.7 5.44394 8.7 5.13591 8.58011 4.90061C8.47465 4.69363 8.30637 4.52535 8.09939 4.41989C7.86409 4.3 7.55606 4.3 6.94 4.3H2.76C2.14394 4.3 1.83591 4.3 1.60061 4.41989C1.39363 4.52535 1.22535 4.69363 1.11989 4.90061C1 5.13591 1 5.44394 1 6.06V10.24C1 10.8561 1 11.1641 1.11989 11.3994C1.22535 11.6064 1.39363 11.7746 1.60061 11.8801C1.83591 12 2.14394 12 2.76 12Z"
          stroke="var(--stroke-color, #667085)"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="settingIcon" viewBox="0 0 18 18" fill="none">
        <path
          d="M7.04628 14.5283L7.48462 15.5142C7.61492 15.8076 7.82757 16.057 8.09678 16.232C8.366 16.4069 8.6802 16.5001 9.00128 16.5C9.32237 16.5001 9.63657 16.4069 9.90578 16.232C10.175 16.057 10.3876 15.8076 10.5179 15.5142L10.9563 14.5283C11.1123 14.1785 11.3748 13.8869 11.7063 13.695C12.0399 13.5026 12.4258 13.4206 12.8088 13.4608L13.8813 13.575C14.2005 13.6088 14.5227 13.5492 14.8088 13.4035C15.0949 13.2578 15.3325 13.0322 15.4929 12.7542C15.6536 12.4763 15.7301 12.1577 15.7132 11.8372C15.6964 11.5166 15.5869 11.2079 15.3979 10.9483L14.7629 10.0758C14.5368 9.76285 14.416 9.38611 14.4179 9C14.4179 8.61494 14.5398 8.23976 14.7663 7.92833L15.4013 7.05583C15.5902 6.79632 15.6997 6.48755 15.7166 6.16701C15.7334 5.84646 15.6569 5.52791 15.4963 5.25C15.3359 4.97193 15.0982 4.74637 14.8121 4.60067C14.5261 4.45497 14.2039 4.3954 13.8846 4.42917L12.8121 4.54333C12.4291 4.58356 12.0432 4.50159 11.7096 4.30917C11.3775 4.11619 11.1149 3.82302 10.9596 3.47167L10.5179 2.48583C10.3876 2.19238 10.175 1.94304 9.90578 1.76805C9.63657 1.59306 9.32237 1.49995 9.00128 1.5C8.6802 1.49995 8.366 1.59306 8.09678 1.76805C7.82757 1.94304 7.61492 2.19238 7.48462 2.48583L7.04628 3.47167C6.89098 3.82302 6.62844 4.11619 6.29628 4.30917C5.96269 4.50159 5.57678 4.58356 5.19378 4.54333L4.11795 4.42917C3.7987 4.3954 3.4765 4.45497 3.19043 4.60067C2.90437 4.74637 2.66671 4.97193 2.50628 5.25C2.34565 5.52791 2.26912 5.84646 2.28598 6.16701C2.30285 6.48755 2.41237 6.79632 2.60128 7.05583L3.23628 7.92833C3.46274 8.23976 3.58468 8.61494 3.58461 9C3.58468 9.38506 3.46274 9.76024 3.23628 10.0717L2.60128 10.9442C2.41237 11.2037 2.30285 11.5124 2.28598 11.833C2.26912 12.1535 2.34565 12.4721 2.50628 12.75C2.66687 13.0279 2.90455 13.2534 3.19058 13.399C3.47661 13.5447 3.79872 13.6044 4.11795 13.5708L5.19045 13.4567C5.57345 13.4164 5.95936 13.4984 6.29295 13.6908C6.62634 13.8833 6.89011 14.1765 7.04628 14.5283Z"
          stroke="#4285F4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.99994 11.25C10.2426 11.25 11.2499 10.2426 11.2499 9C11.2499 7.75736 10.2426 6.75 8.99994 6.75C7.7573 6.75 6.74994 7.75736 6.74994 9C6.74994 10.2426 7.7573 11.25 8.99994 11.25Z"
          stroke="#4285F4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <!-- Page builder icons [END] -->
    </svg>
  `,
})
export class GlobalSvgSpriteComponent {}
